export default function PaymentDueIcon() {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Circle */}
            <circle cx="12" cy="12" r="9" />

            {/* Clock hands */}
            <path d="M12 8v5l3 2" />
        </svg>
    );
}
